import { render, staticRenderFns } from "./OrdersCurrentByProducer.vue?vue&type=template&id=7db177a6&"
import script from "./OrdersCurrentByProducer.vue?vue&type=script&lang=js&"
export * from "./OrdersCurrentByProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports